import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=142b461e&lang=html"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"
import style0 from "./Position.vue?vue&type=style&index=0&id=142b461e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports